import * as React from 'react';

export const BadRoute = () => <div>We're sorry, but this page does not exist</div>;
